import * as React from "react"
import { Container } from "reactstrap"
import { MegaMenu, CartMini, Picture } from "components"
import { useCart, useOutsideAlerter, useControlledInput } from "hooks"
import { toPersianDigits } from "utils"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { ReactComponent as BasketIcon } from "media/svg/basketFill.svg"

import logo from "media/images/logo.png"
import logo2x from "media/images/logo@2x.png"
import logo3x from "media/images/logo@3x.png"

import logoWebP from "media/images/logo.webp"
import logo2xWebP from "media/images/logo@2x.webp"
import logo3xWebP from "media/images/logo@3x.webp"

import "./header.scss"

function useMiniCart(pathname: string) {
	const [showCart, setShowCart] = React.useState(false)
	const buttonRef = React.useRef<HTMLDivElement>(null!)
	const toggleRef = React.useRef<HTMLButtonElement>(null!)

	// pages that mini cart should not open
	const canOpenCart = !["/cart"].includes(pathname)

	// close mini cart on outside page click
	useOutsideAlerter(buttonRef, (event: MouseEvent) => {
		if (event.target === toggleRef.current) {
			setShowCart((prevState) => !prevState && canOpenCart)
			return
		}

		setShowCart(false)
	})

	// close mini cart on page location change
	React.useEffect(() => {
		setShowCart(false)
	}, [pathname])

	return {
		showCart,
		setShowCart: (newState: boolean) =>
			setShowCart(canOpenCart ? newState : false),
		buttonRef,
		toggleRef,
	}
}

const Header: React.FC<RouteComponentProps<null>> = ({ location, history }) => {
	const { quantity } = useCart()
	const { showCart, buttonRef, toggleRef } = useMiniCart(location.pathname)
	const [search, onChange, setSearch] = useControlledInput("")

	function searchInputOnKeyDown(
		event: React.KeyboardEvent<HTMLInputElement>
	) {
		if (event.key === "Enter" && search.trim() !== "") {
			history.push(`/search/${search}`)
			setSearch("")
		}
	}

	return (
		<div className="header__container">
			<div className="header">
				<Container>
					<div className="d-flex flex-wrap align-items-center justify-content-between w-100">
						<Picture
							className="header__logo"
							alt="logo"
							src={logo}
							srcSet={`${logo2x} 2x, ${logo3x} 3x`}
							webP={`${logoWebP} 1x, ${logo2xWebP} 2x, ${logo3xWebP} 3x`}
						/>
						<input
							type="text"
							className="form-control header__search order-3 order-md-0"
							placeholder="هر چیز که در جستن آنی"
							value={search}
							onChange={onChange}
							onKeyDown={searchInputOnKeyDown}
						/>
						<div className="position-relative">
							<button
								ref={toggleRef}
								className="btn btn-jade header__basket"
							>
								سبد خرید{" "}
								<span className="header__basket__badge">
									{toPersianDigits(quantity)}
								</span>
								<BasketIcon className="header__basket__icon" />
							</button>
							<CartMini ref={buttonRef} open={showCart} />
						</div>
					</div>
				</Container>
			</div>
			<MegaMenu />
		</div>
	)
}

export default withRouter(Header)
